/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Admin_Resources_Photos_Input_HintInputs */

const en_admin_resources_photos_input_hint = /** @type {(inputs: Admin_Resources_Photos_Input_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Up to ${i?.max} additional photos`)
};

/** @type {(inputs: Admin_Resources_Photos_Input_HintInputs) => LocalizedString} */
const de_admin_resources_photos_input_hint = en_admin_resources_photos_input_hint;

/** @type {(inputs: Admin_Resources_Photos_Input_HintInputs) => LocalizedString} */
const es_admin_resources_photos_input_hint = en_admin_resources_photos_input_hint;

/** @type {(inputs: Admin_Resources_Photos_Input_HintInputs) => LocalizedString} */
const fr_admin_resources_photos_input_hint = en_admin_resources_photos_input_hint;

/** @type {(inputs: Admin_Resources_Photos_Input_HintInputs) => LocalizedString} */
const it_admin_resources_photos_input_hint = en_admin_resources_photos_input_hint;

/** @type {(inputs: Admin_Resources_Photos_Input_HintInputs) => LocalizedString} */
const pt_br2_admin_resources_photos_input_hint = en_admin_resources_photos_input_hint;

/** @type {(inputs: Admin_Resources_Photos_Input_HintInputs) => LocalizedString} */
const pl_admin_resources_photos_input_hint = en_admin_resources_photos_input_hint;

/** @type {(inputs: Admin_Resources_Photos_Input_HintInputs) => LocalizedString} */
const hu_admin_resources_photos_input_hint = en_admin_resources_photos_input_hint;

/** @type {(inputs: Admin_Resources_Photos_Input_HintInputs) => LocalizedString} */
const ro_admin_resources_photos_input_hint = en_admin_resources_photos_input_hint;

/**
* | output |
* | --- |
* | "Up to {max} additional photos" |
*
* @param {Admin_Resources_Photos_Input_HintInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_photos_input_hint = /** @type {((inputs: Admin_Resources_Photos_Input_HintInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Photos_Input_HintInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_photos_input_hint(inputs)
	if (locale === "de") return de_admin_resources_photos_input_hint(inputs)
	if (locale === "es") return es_admin_resources_photos_input_hint(inputs)
	if (locale === "fr") return fr_admin_resources_photos_input_hint(inputs)
	if (locale === "it") return it_admin_resources_photos_input_hint(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_photos_input_hint(inputs)
	if (locale === "pl") return pl_admin_resources_photos_input_hint(inputs)
	if (locale === "hu") return hu_admin_resources_photos_input_hint(inputs)
	return ro_admin_resources_photos_input_hint(inputs)
});
export { admin_resources_photos_input_hint as "admin.resources.photos_input.hint" }